import type Phaser from 'phaser';
import { allowedMowers } from '../../content/levelSchema';
import { customLevel, type CustomLawn } from '../../meta/customLawns';
import { saves } from '../records';
import type { LevelCardData } from './LevelCardScene';
import { wipeTo } from './WipeScene';

/** The lawn the builder last had open (so the card's Back and the level's EDIT return to it). */
export const REG_BUILDER_LAWN = 'builder.lawn';

/**
 * Plays a checked lawn of your own: its level card, offering your mowers that clear it. Like a
 * test lawn it pays nothing and earns no stars; leaving it goes back to the builder (or, for a
 * shared lawn not kept in My Lawns, to My Lawns). Returns false (nothing opens) when none of your
 * mowers can clear it.
 */
export function playCustomLawn(
  scene: Phaser.Scene,
  lawn: Readonly<CustomLawn>,
  {
    kept = true,
    back: given,
    community,
    ghost,
  }: {
    kept?: boolean;
    /** Where DONE leads (a community lawn: back to the community browser). */
    back?: { scene: string; label: string; data: object };
    /** A community lawn: its id and code, so a clear goes on its board. */
    community?: { id: string; code: string };
    /** Its best run, to race. */
    ghost?: LevelCardData['ghost'];
  } = {},
): boolean {
  const level = customLevel(lawn);
  const save = saves().save;
  const choices = allowedMowers(level.mowerRule).filter((id) => save.ownedMowers.includes(id));
  if (choices.length === 0) return false;
  if (kept) scene.registry.set(REG_BUILDER_LAWN, lawn.id);
  const back =
    given ??
    (kept
      ? { scene: 'Builder', label: 'Edit', data: { lawnId: lawn.id } }
      : { scene: 'MyLawns', label: 'Done', data: {} });
  const data: LevelCardData = {
    level,
    choices,
    backTo: back.scene,
    backData: back.data,
    ...(ghost ? { ghost } : {}),
    playlist: {
      kind: 'test',
      short: 'My lawn',
      levels: [level],
      index: 0,
      back,
      ...(community ? { community } : {}),
    },
  };
  wipeTo(scene, 'LevelCard', data);
  return true;
}
